import { createThunkEffect } from "../../utilities/ActionUtility";
import * as QuotaEffect from "./QuotaEffect";

export const REQUEST_ALL_QUOTAS = "QuotaEffect.REQUEST_ALL_QUOTAS";
export const REQUEST_ALL_QUOTAS_FINISHED = "QuotaEffect.REQUEST_ALL_QUOTAS_FINISHED";

export function requestAllQuotas() {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_ALL_QUOTAS, QuotaEffect.requestAllQuotas);
    };
}

export const REQUEST_ADD_QUOTA = "QuotaEffect.REQUEST_ADD_QUOTA";
export const REQUEST_ADD_QUOTA_FINISHED = "QuotaEffect.REQUEST_ADD_QUOTA_FINISHED";

export function addQuota(quota) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_ADD_QUOTA, QuotaEffect.addQuota, quota);
    };
}

export const REQUEST_QUOTA = "QuotaEffect.REQUEST_QUOTA";
export const REQUEST_QUOTA_FINISHED = "QuotaEffect.REQUEST_QUOTA_FINISHED";

export function requestQuota(id) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_QUOTA, QuotaEffect.requestQuota, id);
    };
}

export const REQUEST_UPDATE_QUOTA = "QuotaEffect.REQUEST_UPDATE_QUOTA";
export const REQUEST_UPDATE_QUOTA_FINISHED = "QuotaEffect.REQUEST_UPDATE_QUOTA_FINISHED";

export function updateQuota(id, quota) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_UPDATE_QUOTA, QuotaEffect.updateQuota, id, quota);
    };
}

export const REQUEST_DELETE_QUOTA = "QuotaEffect.REQUEST_DELETE_QUOTA";
export const REQUEST_DELETE_QUOTA_FINISHED = "QuotaEffect.REQUEST_DELETE_QUOTA_FINISHED";

export function deleteQuote(id) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_DELETE_QUOTA, QuotaEffect.deleteQuote, id);
    };
}

export const REQUEST_QUOTA_ORDERS = "QuotaEffect.REQUEST_QUOTA_ORDERS";
export const REQUEST_QUOTA_ORDERS_FINISHED = "QuotaEffect.REQUEST_QUOTA_ORDERS_FINISHED";

export function requestQuotaOrders(id) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_QUOTA_ORDERS, QuotaEffect.requestQuotaOrders, id);
    };
}

export const REQUEST_USER_QUOTA = "QuotaEffect.REQUEST_USER_QUOTA";
export const REQUEST_USER_QUOTA_FINISHED = "QuotaEffect.REQUEST_USER_QUOTA_FINISHED";

export function requestUserQuota(userId) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_USER_QUOTA, QuotaEffect.requestUserQuota, userId);
    };
}
